// src/components/LandingMarketTable.js

import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import './LandingMarketTable.css';

const SYMBOLS = [
  'AAPL','TSLA','AMZN','MSFT','NVDA','GOOGL','META','NFLX','JPM','V','BAC',
  'PYPL','DIS','T','PFE','COST','INTC','KO','TGT','NKE','SPY'
];

function formatNumber(n) {
  if (n == null) return '—';
  if (n >= 1e12) return `${(n / 1e12).toFixed(1)}T`;
  if (n >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  return n.toLocaleString();
}

export default function LandingMarketTable() {
  const [rows, setRows] = useState([]);
  // const navigate = useNavigate();

  useEffect(() => {
    Promise.all(
      SYMBOLS.map(symbol =>
        fetch(`/data/${symbol}/landing.json`)
          .then(r => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    ).then(data => {
      setRows(data.filter(Boolean));
    });
  }, []);

  return (
    <div className="landing-market-table">
      <table>
        <thead>
          <tr>
            <th>Stock</th>
            <th>Price</th>
            <th>Change</th>
            <th>Market Cap</th>
            <th>Volume</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr
              key={row.symbol}
            //   onClick={() => navigate(`/visualization?symbol=${row.symbol}`)}
            >
              <td className="symbol-cell">
                <strong>{row.symbol}</strong>
                <span>{row.name}</span>
              </td>
              <td>${row.price.toFixed(2)}</td>
              <td className={row.changePercent >= 0 ? 'pos' : 'neg'}>
                {row.changePercent.toFixed(2)}%
              </td>
              <td>{formatNumber(row.marketCap)}</td>
              <td>{formatNumber(row.volume)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
